@if (schema) { @for (item of schema.items; track item) {
<ng-container *epcDynamicComponentIf="item.if">
  <ng-template
    [epcDynamicComponent]="{
      contentTypeId: item.contentTypeId
    }"
    [inputs]="item.inputs"
    [styles]="item.styles"
    [children]="item.children"
    [data]="item.data"
  ></ng-template>
</ng-container>
} }
